// Country dial-code list mirrors legacy
// enterprise-app/src/components/createNewProptree.js verbatim (~lines
// 722-955). Stored on `proptree.whatsAppCountryCode` as the legacy enum
// shape `{ id, name, value }`.

export interface CountryCode {
  id: number;
  name: string;
  value: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { id: 9, name: 'Denmark (+45)', value: '45' },
  { id: 7, name: 'France (+33)', value: '33' },
  { id: 4, name: 'Germany (+49)', value: '49' },
  { id: 5, name: 'Ireland (+353)', value: '353' },
  { id: 6, name: 'Norway (+47)', value: '47' },
  { id: 3, name: 'Sweden (+46)', value: '46' },
  { id: 8, name: 'Switzerland (+41)', value: '41' },
  { id: 2, name: 'UK (+44)', value: '44' },
  { id: 10, name: 'Australia (+61)', value: '61' },
  { id: 11, name: 'Canada/US (+1)', value: '1' },
  { id: 12, name: 'India (+91)', value: '91' },
  { id: 13, name: 'Israel (+972)', value: '972' },
  { id: 14, name: 'New Zealand (+64)', value: '64' },
  { id: 15, name: 'Qatar (+974)', value: '974' },
  { id: 16, name: 'Saudi Arabia (+966)', value: '966' },
  { id: 17, name: 'South Africa (+27)', value: '27' },
  { id: 1, name: 'UAE (+971)', value: '971' },
  { id: 19, name: 'Spain (+34)', value: '34' },
  { id: 20, name: 'Portugal (+351)', value: '351' },
  { id: 21, name: 'Netherlands (+31)', value: '31' },
  { id: 22, name: 'Italy (+39)', value: '39' },
  { id: 23, name: 'Afghanistan (+93)', value: '93' },
  { id: 24, name: 'Albania (+355)', value: '355' },
  { id: 25, name: 'Algeria (+213)', value: '213' },
  { id: 26, name: 'American Samoa (+1684)', value: '1684' },
  { id: 27, name: 'Andorra (+376)', value: '376' },
  { id: 28, name: 'Angola (+244)', value: '244' },
  { id: 29, name: 'Antigua & Barbuda (+1268)', value: '1268' },
  { id: 30, name: 'Argentina (+54)', value: '54' },
  { id: 31, name: 'Armenia (+374)', value: '374' },
  { id: 32, name: 'Austria (+43)', value: '43' },
  { id: 33, name: 'Azerbaijan (+994)', value: '994' },
  { id: 34, name: 'Bahamas (+1242)', value: '1242' },
  { id: 35, name: 'Bahrain (+973)', value: '973' },
  { id: 36, name: 'Bangladesh (+880)', value: '880' },
  { id: 37, name: 'Barbados (+1246)', value: '1246' },
  { id: 38, name: 'Belarus (+375)', value: '375' },
  { id: 39, name: 'Belgium (+32)', value: '32' },
  { id: 40, name: 'Belize (+501)', value: '501' },
  { id: 41, name: 'Benin (+229)', value: '229' },
  { id: 42, name: 'Bhutan (+975)', value: '975' },
  { id: 43, name: 'Bolivia (+591)', value: '591' },
  { id: 44, name: 'Bosnia & Herzegovina (+387)', value: '387' },
  { id: 45, name: 'Botswana (+267)', value: '267' },
  { id: 46, name: 'Brazil (+55)', value: '55' },
  { id: 47, name: 'Brunei (+673)', value: '673' },
  { id: 48, name: 'Bulgaria (+359)', value: '359' },
  { id: 49, name: 'Burkina Faso (+226)', value: '226' },
  { id: 50, name: 'Burundi (+257)', value: '257' },
  { id: 51, name: 'Cabo Verde (+238)', value: '238' },
  { id: 52, name: 'Cambodia (+855)', value: '855' },
  { id: 53, name: 'Cameroon (+237)', value: '237' },
  { id: 54, name: 'Central African Republic (+236)', value: '236' },
  { id: 55, name: 'Chad (+235)', value: '235' },
  { id: 56, name: 'Chile (+56)', value: '56' },
  { id: 57, name: 'China (+86)', value: '86' },
  { id: 58, name: 'Colombia (+57)', value: '57' },
  { id: 59, name: 'Comoros (+269)', value: '269' },
  { id: 60, name: 'Congo (+242)', value: '242' },
  { id: 61, name: 'Costa Rica (+506)', value: '506' },
  { id: 62, name: 'Croatia (+385)', value: '385' },
  { id: 63, name: 'Cuba (+53)', value: '53' },
  { id: 64, name: 'Cyprus (+357)', value: '357' },
  { id: 65, name: 'Czech Republic (+420)', value: '420' },
  { id: 66, name: 'Djibouti (+253)', value: '253' },
  { id: 67, name: 'Dominica (+1767)', value: '1767' },
  { id: 68, name: 'Dominican Republic (+1809)', value: '1809' },
  { id: 69, name: 'Ecuador (+593)', value: '593' },
  { id: 70, name: 'Egypt (+20)', value: '20' },
  { id: 71, name: 'El Salvador (+503)', value: '503' },
  { id: 72, name: 'Equatorial Guinea (+240)', value: '240' },
  { id: 73, name: 'Eritrea (+291)', value: '291' },
  { id: 74, name: 'Estonia (+372)', value: '372' },
  { id: 75, name: 'Eswatini (+268)', value: '268' },
  { id: 76, name: 'Ethiopia (+251)', value: '251' },
  { id: 77, name: 'Fiji (+679)', value: '679' },
  { id: 78, name: 'Finland (+358)', value: '358' },
  { id: 79, name: 'Gabon (+241)', value: '241' },
  { id: 80, name: 'Gambia (+220)', value: '220' },
  { id: 81, name: 'Georgia (+995)', value: '995' },
  { id: 82, name: 'Ghana (+233)', value: '233' },
  { id: 83, name: 'Greece (+30)', value: '30' },
  { id: 84, name: 'Grenada (+1473)', value: '1473' },
  { id: 85, name: 'Guatemala (+502)', value: '502' },
  { id: 86, name: 'Guinea (+224)', value: '224' },
  { id: 87, name: 'Guinea-Bissau (+245)', value: '245' },
  { id: 88, name: 'Guyana (+592)', value: '592' },
  { id: 89, name: 'Haiti (+509)', value: '509' },
  { id: 90, name: 'Honduras (+504)', value: '504' },
  { id: 195, name: 'Hong Kong (+852)', value: '852' },
  { id: 91, name: 'Hungary (+36)', value: '36' },
  { id: 92, name: 'Iceland (+354)', value: '354' },
  { id: 93, name: 'Indonesia (+62)', value: '62' },
  { id: 94, name: 'Iran (+98)', value: '98' },
  { id: 95, name: 'Iraq (+964)', value: '964' },
  { id: 98, name: 'Jamaica (+1876)', value: '1876' },
  { id: 99, name: 'Japan (+81)', value: '81' },
  { id: 100, name: 'Jordan (+962)', value: '962' },
  { id: 101, name: 'Kazakhstan (+7)', value: '7' },
  { id: 102, name: 'Kenya (+254)', value: '254' },
  { id: 103, name: 'Kiribati (+686)', value: '686' },
  { id: 105, name: 'Kuwait (+965)', value: '965' },
  { id: 106, name: 'Kyrgyzstan (+996)', value: '996' },
  { id: 107, name: 'Laos (+856)', value: '856' },
  { id: 108, name: 'Latvia (+371)', value: '371' },
  { id: 109, name: 'Lebanon (+961)', value: '961' },
  { id: 110, name: 'Lesotho (+266)', value: '266' },
  { id: 111, name: 'Liberia (+231)', value: '231' },
  { id: 112, name: 'Libya (+218)', value: '218' },
  { id: 113, name: 'Liechtenstein (+423)', value: '423' },
  { id: 114, name: 'Lithuania (+370)', value: '370' },
  { id: 115, name: 'Luxembourg (+352)', value: '352' },
  { id: 116, name: 'Madagascar (+261)', value: '261' },
  { id: 117, name: 'Malawi (+265)', value: '265' },
  { id: 118, name: 'Malaysia (+60)', value: '60' },
  { id: 119, name: 'Maldives (+960)', value: '960' },
  { id: 120, name: 'Mali (+223)', value: '223' },
  { id: 121, name: 'Malta (+356)', value: '356' },
  { id: 122, name: 'Marshall Islands (+692)', value: '692' },
  { id: 123, name: 'Mauritania (+222)', value: '222' },
  { id: 124, name: 'Mauritius (+230)', value: '230' },
  { id: 125, name: 'Mexico (+52)', value: '52' },
  { id: 126, name: 'Micronesia (+691)', value: '691' },
  { id: 127, name: 'Moldova (+373)', value: '373' },
  { id: 128, name: 'Monaco (+377)', value: '377' },
  { id: 129, name: 'Mongolia (+976)', value: '976' },
  { id: 130, name: 'Montenegro (+382)', value: '382' },
  { id: 131, name: 'Morocco (+212)', value: '212' },
  { id: 132, name: 'Mozambique (+258)', value: '258' },
  { id: 133, name: 'Myanmar (+95)', value: '95' },
  { id: 134, name: 'Namibia (+264)', value: '264' },
  { id: 135, name: 'Nauru (+674)', value: '674' },
  { id: 136, name: 'Nepal (+977)', value: '977' },
  { id: 137, name: 'Nicaragua (+505)', value: '505' },
  { id: 138, name: 'Niger (+227)', value: '227' },
  { id: 139, name: 'Nigeria (+234)', value: '234' },
  { id: 140, name: 'North Macedonia (+389)', value: '389' },
  { id: 142, name: 'Oman (+968)', value: '968' },
  { id: 143, name: 'Pakistan (+92)', value: '92' },
  { id: 144, name: 'Palau (+680)', value: '680' },
  { id: 145, name: 'Panama (+507)', value: '507' },
  { id: 146, name: 'Papua New Guinea (+675)', value: '675' },
  { id: 147, name: 'Paraguay (+595)', value: '595' },
  { id: 148, name: 'Peru (+51)', value: '51' },
  { id: 149, name: 'Philippines (+63)', value: '63' },
  { id: 150, name: 'Poland (+48)', value: '48' },
  { id: 151, name: 'Romania (+40)', value: '40' },
  { id: 152, name: 'Russia (+7)', value: '7' },
  { id: 153, name: 'Rwanda (+250)', value: '250' },
  { id: 154, name: 'Saint Kitts & Nevis (+1869)', value: '1869' },
  { id: 155, name: 'Saint Lucia (+1758)', value: '1758' },
  { id: 156, name: 'Saint Vincent & Grenadines (+1784)', value: '1784' },
  { id: 157, name: 'Samoa (+685)', value: '685' },
  { id: 158, name: 'San Marino (+378)', value: '378' },
  { id: 159, name: 'Sao Tome & Principe (+239)', value: '239' },
  { id: 160, name: 'Senegal (+221)', value: '221' },
  { id: 161, name: 'Serbia (+381)', value: '381' },
  { id: 162, name: 'Seychelles (+248)', value: '248' },
  { id: 163, name: 'Sierra Leone (+232)', value: '232' },
  { id: 164, name: 'Singapore (+65)', value: '65' },
  { id: 165, name: 'Slovakia (+421)', value: '421' },
  { id: 166, name: 'Slovenia (+386)', value: '386' },
  { id: 167, name: 'Solomon Islands (+677)', value: '677' },
  { id: 168, name: 'South Korea (+82)', value: '82' },
  { id: 169, name: 'South Sudan (+211)', value: '211' },
  { id: 170, name: 'Sri Lanka (+94)', value: '94' },
];
